import React from "react";
import { X, Plus } from "lucide-react";

export default function POAddCustomerModal({
  isOpen,
  onClose,
  customerForm,
  setCustomerForm,
  onSubmit,
  customerCategories,
  paymentMethods = [],
  loading
}) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxHeight: "85vh", overflowY: "auto" }}>
        <div className="modal-header">
          <h3>Register New Customer</h3>
          <button className="modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <form onSubmit={onSubmit}>
          {/* Company Name */}
          <div className="form-group">
            <label className="form-label" htmlFor="cust-name">Customer Company Name *</label>
            <input
              id="cust-name"
              type="text"
              required
              className="form-input"
              placeholder="e.g. Nexus Enterprises Inc."
              value={customerForm.name}
              onChange={(e) => setCustomerForm({ ...customerForm, name: e.target.value })}
            />
          </div>

          {/* Category */}
          <div className="form-group">
            <label className="form-label" htmlFor="cust-category">Category *</label>
            <select
              id="cust-category"
              className="form-input"
              value={customerForm.category}
              onChange={(e) => setCustomerForm({ ...customerForm, category: e.target.value })}
              required
            >
              {customerCategories.map(cat => (
                <option key={cat} value={cat}>{cat}</option>
              ))}
            </select>
          </div>

          {/* Preferred Payment Method */}
          <div className="form-group">
            <label className="form-label" htmlFor="cust-preferredPaymentMethod">Preferred Payment Method</label>
            <select
              id="cust-preferredPaymentMethod"
              className="form-input"
              value={customerForm.preferredPaymentMethod || ""}
              onChange={(e) => setCustomerForm({ ...customerForm, preferredPaymentMethod: e.target.value })}
            >
              <option value="">None Selected</option>
              {paymentMethods && paymentMethods.map(pm => (
                <option key={pm.id} value={pm.name}>{pm.name}</option>
              ))}
            </select>
          </div>

          {/* Company Address Section */}
          <div style={{ marginTop: "1.25rem", borderTop: "1px solid var(--border-color)", paddingTop: "1rem" }}>
            <h4 style={{ margin: "0 0 0.75rem 0", fontSize: "0.95rem", color: "var(--primary)" }}>Company Address</h4>
            <div className="form-group">
              <label className="form-label" htmlFor="cust-address">Street Address</label>
              <input
                id="cust-address"
                type="text"
                className="form-input"
                placeholder="e.g. 100 Innovation Way"
                value={customerForm.address}
                onChange={(e) => setCustomerForm({ ...customerForm, address: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="cust-address2">Suite / Unit / Building</label>
              <input
                id="cust-address2"
                type="text"
                className="form-input"
                placeholder="e.g. Suite 200"
                value={customerForm.address2}
                onChange={(e) => setCustomerForm({ ...customerForm, address2: e.target.value })}
              />
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1.5fr 0.7fr 0.8fr", gap: "0.75rem" }}>
              <div className="form-group">
                <label className="form-label" htmlFor="cust-city">City</label>
                <input
                  id="cust-city"
                  type="text"
                  className="form-input"
                  placeholder="e.g. New York"
                  value={customerForm.city}
                  onChange={(e) => setCustomerForm({ ...customerForm, city: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="cust-state">State</label>
                <input
                  id="cust-state"
                  type="text"
                  className="form-input"
                  placeholder="e.g. NY"
                  value={customerForm.state}
                  onChange={(e) => setCustomerForm({ ...customerForm, state: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="cust-zip">ZIP / Postal Code</label>
                <input
                  id="cust-zip"
                  type="text"
                  className="form-input"
                  placeholder="e.g. 10001"
                  value={customerForm.zip}
                  onChange={(e) => setCustomerForm({ ...customerForm, zip: e.target.value })}
                />
              </div>
            </div>
          </div>

          {/* Billing Address Section */}
          <div style={{ marginTop: "1.25rem", borderTop: "1px solid var(--border-color)", paddingTop: "1rem" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.75rem" }}>
              <h4 style={{ margin: 0, fontSize: "0.95rem", color: "var(--primary)" }}>Bill To Address</h4>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setCustomerForm({
                  ...customerForm,
                  billAddress: customerForm.address || "",
                  billAddress2: customerForm.address2 || "",
                  billCity: customerForm.city || "",
                  billState: customerForm.state || "",
                  billZip: customerForm.zip || ""
                })}
                style={{ padding: "0.2rem 0.5rem", minHeight: "auto", fontSize: "0.75rem", textTransform: "none" }}
              >
                Copy Shipping Address
              </button>
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="cust-bill-address">Street Address</label>
              <input
                id="cust-bill-address"
                type="text"
                className="form-input"
                placeholder="e.g. 100 Innovation Way"
                value={customerForm.billAddress || ""}
                onChange={(e) => setCustomerForm({ ...customerForm, billAddress: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="cust-bill-address2">Suite / Unit / Building</label>
              <input
                id="cust-bill-address2"
                type="text"
                className="form-input"
                placeholder="e.g. Suite 200"
                value={customerForm.billAddress2 || ""}
                onChange={(e) => setCustomerForm({ ...customerForm, billAddress2: e.target.value })}
              />
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1.5fr 0.7fr 0.8fr", gap: "0.75rem" }}>
              <div className="form-group">
                <label className="form-label" htmlFor="cust-bill-city">City</label>
                <input
                  id="cust-bill-city"
                  type="text"
                  className="form-input"
                  placeholder="e.g. New York"
                  value={customerForm.billCity || ""}
                  onChange={(e) => setCustomerForm({ ...customerForm, billCity: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="cust-bill-state">State</label>
                <input
                  id="cust-bill-state"
                  type="text"
                  className="form-input"
                  placeholder="e.g. NY"
                  value={customerForm.billState || ""}
                  onChange={(e) => setCustomerForm({ ...customerForm, billState: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="cust-bill-zip">ZIP Code</label>
                <input
                  id="cust-bill-zip"
                  type="text"
                  className="form-input"
                  placeholder="e.g. 10001"
                  value={customerForm.billZip || ""}
                  onChange={(e) => setCustomerForm({ ...customerForm, billZip: e.target.value })}
                />
              </div>
            </div>
          </div>

          {/* Ship To Address Section */}
          <div style={{ marginTop: "1.25rem", borderTop: "1px solid var(--border-color)", paddingTop: "1rem" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.75rem" }}>
              <h4 style={{ margin: 0, fontSize: "0.95rem", color: "var(--primary)" }}>Ship To Address</h4>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setCustomerForm({
                  ...customerForm,
                  shipAddress: customerForm.address || "",
                  shipAddress2: customerForm.address2 || "",
                  shipCity: customerForm.city || "",
                  shipState: customerForm.state || "",
                  shipZip: customerForm.zip || ""
                })}
                style={{ padding: "0.2rem 0.5rem", minHeight: "auto", fontSize: "0.75rem", textTransform: "none" }}
              >
                Copy Company Address
              </button>
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="cust-ship-address">Street Address</label>
              <input
                id="cust-ship-address"
                type="text"
                className="form-input"
                placeholder="e.g. 7000 Loisdale Rd"
                value={customerForm.shipAddress || ""}
                onChange={(e) => setCustomerForm({ ...customerForm, shipAddress: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="cust-ship-address2">Dock / Building / Suite</label>
              <input
                id="cust-ship-address2"
                type="text"
                className="form-input"
                placeholder="e.g. Warehouse BldgG, Dock 2"
                value={customerForm.shipAddress2 || ""}
                onChange={(e) => setCustomerForm({ ...customerForm, shipAddress2: e.target.value })}
              />
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1.5fr 0.7fr 0.8fr", gap: "0.75rem" }}>
              <div className="form-group">
                <label className="form-label" htmlFor="cust-ship-city">City</label>
                <input
                  id="cust-ship-city"
                  type="text"
                  className="form-input"
                  placeholder="e.g. Newington"
                  value={customerForm.shipCity || ""}
                  onChange={(e) => setCustomerForm({ ...customerForm, shipCity: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="cust-ship-state">State</label>
                <input
                  id="cust-ship-state"
                  type="text"
                  className="form-input"
                  placeholder="e.g. VA"
                  value={customerForm.shipState || ""}
                  onChange={(e) => setCustomerForm({ ...customerForm, shipState: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="cust-ship-zip">ZIP Code</label>
                <input
                  id="cust-ship-zip"
                  type="text"
                  className="form-input"
                  placeholder="e.g. 22150"
                  value={customerForm.shipZip || ""}
                  onChange={(e) => setCustomerForm({ ...customerForm, shipZip: e.target.value })}
                />
              </div>
            </div>

            {/* Mark For (M/F) */}
            <div className="form-group" style={{ marginTop: "1rem" }}>
              <label className="form-label" htmlFor="cust-ship-markfor">Mark For (M/F)</label>
              <input
                id="cust-ship-markfor"
                type="text"
                className="form-input"
                placeholder="e.g. M/F: 2025-795632 Bozer, VA 22150"
                value={customerForm.markFor || ""}
                onChange={(e) => setCustomerForm({ ...customerForm, markFor: e.target.value })}
              />
            </div>
          </div>

          {/* Points of Contact List */}
          <div style={{ marginTop: "1.25rem", borderTop: "1px solid var(--border-color)", paddingTop: "1rem", marginBottom: "1rem" }}>
            <h4 style={{ margin: "0 0 0.75rem 0", fontSize: "0.95rem", color: "var(--primary)" }}>Points of Contact</h4>
            {customerForm.pocs && customerForm.pocs.map((poc, index) => (
              <div key={index} style={{ border: "1px solid var(--border-color)", padding: "1rem", borderRadius: "6px", marginBottom: "1rem", backgroundColor: "rgba(255, 255, 255, 0.01)", position: "relative" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.75rem" }}>
                  <span style={{ fontSize: "0.9rem", fontWeight: "600", color: "var(--primary)" }}>Contact #{index + 1}</span>
                  {customerForm.pocs.length > 1 && (
                    <button 
                      type="button" 
                      className="btn btn-secondary" 
                      onClick={() => {
                        const updatedPocs = customerForm.pocs.filter((_, i) => i !== index);
                        setCustomerForm({ ...customerForm, pocs: updatedPocs });
                      }}
                      style={{ padding: "0.15rem 0.5rem", minHeight: "auto", fontSize: "0.75rem", color: "var(--danger)", borderColor: "var(--danger)" }}
                    >
                      Remove POC
                    </button>
                  )}
                </div>
                
                <div style={{ display: "grid", gridTemplateColumns: "1.2fr 0.8fr", gap: "0.75rem" }}>
                  <div className="form-group">
                    <label className="form-label" htmlFor={`cust-poc-name-${index}`}>Contact Name</label>
                    <input
                      id={`cust-poc-name-${index}`}
                      type="text"
                      className="form-input"
                      placeholder="e.g. John Doe"
                      value={poc.name}
                      onChange={(e) => {
                        const updatedPocs = [...customerForm.pocs];
                        updatedPocs[index] = { ...updatedPocs[index], name: e.target.value };
                        setCustomerForm({ ...customerForm, pocs: updatedPocs });
                      }}
                      style={{ margin: 0 }}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label" htmlFor={`cust-poc-title-${index}`}>POC Title</label>
                    <input
                      id={`cust-poc-title-${index}`}
                      type="text"
                      className="form-input"
                      placeholder="e.g. Purchasing Manager"
                      value={poc.title}
                      onChange={(e) => {
                        const updatedPocs = [...customerForm.pocs];
                        updatedPocs[index] = { ...updatedPocs[index], title: e.target.value };
                        setCustomerForm({ ...customerForm, pocs: updatedPocs });
                      }}
                      style={{ margin: 0 }}
                    />
                  </div>
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1.2fr 0.8fr", gap: "0.75rem", marginTop: "0.5rem" }}>
                  <div className="form-group" style={{ marginBottom: 0 }}>
                    <label className="form-label" htmlFor={`cust-poc-email-${index}`}>Email Address</label>
                    <input
                      id={`cust-poc-email-${index}`}
                      type="email"
                      className="form-input"
                      placeholder="e.g. john@customer.com"
                      value={poc.email}
                      onChange={(e) => {
                        const updatedPocs = [...customerForm.pocs];
                        updatedPocs[index] = { ...updatedPocs[index], email: e.target.value };
                        setCustomerForm({ ...customerForm, pocs: updatedPocs });
                      }}
                      style={{ margin: 0 }}
                    />
                  </div>
                  <div className="form-group" style={{ marginBottom: 0 }}>
                    <label className="form-label" htmlFor={`cust-poc-phone-${index}`}>Phone Number</label>
                    <input
                      id={`cust-poc-phone-${index}`}
                      type="text"
                      className="form-input"
                      placeholder="e.g. 555-0100"
                      value={poc.phone}
                      onChange={(e) => {
                        const updatedPocs = [...customerForm.pocs];
                        updatedPocs[index] = { ...updatedPocs[index], phone: e.target.value };
                        setCustomerForm({ ...customerForm, pocs: updatedPocs });
                      }}
                      style={{ margin: 0 }}
                    />
                  </div>
                </div>
              </div>
            ))}

            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setCustomerForm({ ...customerForm, pocs: [...customerForm.pocs, { name: "", title: "", email: "", phone: "" }] })}
              style={{ display: "flex", alignItems: "center", gap: "0.5rem", width: "100%", justifyContent: "center", borderStyle: "dashed" }}
            >
              <Plus size={16} />
              Add Point of Contact
            </button>
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.75rem", marginTop: "1.5rem" }}>
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              Register Customer
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
